import { send } from '../../../../../../src/network/network';
import { type PaginatedPeriodicityListList } from '../../../../../../src/types/PaginatedPeriodicityListList';
export {
  CustomerPeriodicityTypes,
  type PaginatedPeriodicityListList,
} from '../../../../../../src/types/PaginatedPeriodicityListList';

export async function getCustomerPeriodicities() {
  const query = new URLSearchParams();

  // maintain a high limit so query invalidation and refetching always ensures any recently PATCHed values
  // are reflected correctly in the UI
  query.set('limit', '10000');

  return await send<PaginatedPeriodicityListList>({
    path: `/api/v2/customers/self/periodicities/`,
    method: 'GET',
    query,
  });
}
